import React, { useRef, useState } from "react"
import { Button, Box } from "@material-ui/core"
import { Formik, Form } from "formik"
import ReusableFormControl from "components/ReusableFormControl"
import * as Yup from "yup"
import { useDispatch } from "react-redux"
import { createGroupCode } from "actions/organization"
import { openSnackBar } from "actions/snack-bar"
import LoaderButton from "components/LoaderButton"
import MaskedOrganizationCode from "../../components/MaskedOrganizationCode"
import DialogsContainerDialog from "../../dialogs/DialogsContainer"

function makeid(length) {
  var result = ""
  var characters =
    "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789"
  var charactersLength = characters.length
  for (var i = 0; i < length; i++) {
    result += characters.charAt(Math.floor(Math.random() * charactersLength))
  }
  return result
}

const groupSchema = Yup.object().shape({
  code: Yup.string()
    .length(6, "Must be 6 characters")
    .required("Required"),
  allowedAccounts: Yup.string()
    .matches(/^[0-9]+$/, "Must be a number")
    .required("Required")
})

const CreateGroup = ({ open, close, org }) => {
  const formRef = useRef(null)
  const [working, setWorking] = useState(false)
  const dispatch = useDispatch()
  const submit = data => {
    setWorking(true)
    data.org_id = org.id
    dispatch(createGroupCode(data))
      .then(() => {
        close(true)
      })
      .catch(err => {
        console.log(err)
        dispatch(openSnackBar({ message: err.message }))
      })
      .finally(() => setWorking(false))
  }
  const randomCode = () => makeid(6)
  return (
    <DialogsContainerDialog
      open={open}
      handleClose={() => close(false)}
      title={`Create Group Code for ${org.name}`}
      content={
        <Formik
          initialValues={{
            code: randomCode(),
            allowedAccounts: 3
          }}
          onSubmit={submit}
          innerRef={formRef}
          validationSchema={groupSchema}
        >
          {formikProps => {
            return (
              <Form>
                <ReusableFormControl
                  name="code"
                  label="code"
                  formikProps={formikProps}
                  inputProps={{
                    inputComponent: MaskedOrganizationCode
                  }}
                />
                <ReusableFormControl
                  name="allowedAccounts"
                  label="Number code uses"
                  formikProps={formikProps}
                  inputProps={{
                    type: "tel"
                  }}
                />
              </Form>
            )
          }}
        </Formik>
      }
      buttons={
        <Box>
          <Button
            color="primary"
            onClick={() => close(false)}
            style={{ marginRight: "16px" }}
          >
            Close
          </Button>
          <LoaderButton
            color="primary"
            working={working}
            onClick={() => formRef.current.submitForm()}
          >
            Create
          </LoaderButton>
        </Box>
      }
      fullScreen={false}
    />
  )
}

export default CreateGroup



// WEBPACK FOOTER //
// ./src/pages/SuperAdmin/createGroup.jsx